import { Name, Show } from "@alloy-js/core";

import type { CommonDeclarationProps } from "./Declaration.js";
import { Declaration } from "./Declaration.js";
import { JSDoc } from "./JSDoc.jsx";
import { ensureTypeRefContext } from "./TypeRefContext.jsx";

export interface TypeDeclarationProps extends CommonDeclarationProps {}

export const TypeDeclaration = ensureTypeRefContext(function TypeDeclaration(
  props: TypeDeclarationProps,
) {
  return (
    <>
      <Show when={Boolean(props.doc)}>
        <JSDoc children={props.doc} />
        <hbr />
      </Show>
      <Declaration {...props} kind="type" nameKind="type">
        type <Name /> = {props.children};
      </Declaration>
    </>
  );
});
